module.exports = __webpack_public_path__ + "img/chat_black_24dp.31acbb23.svg";